import { InputFieldV5, SelectV5, TextareaV5 } from "components/form";

const INPUT_FIELDS = [
  {
    name: "date",
    group: "common",
    type: "date",
    icon: "far fa-calendar-alt",
    className: "input ",
    component: InputFieldV5,
    required: true,
    readOnly: true,
  },
  {
    name: "email",
    group: "register",
    type: "email",
    icon: "fa fa-envelope",
    className: "input ",
    component: InputFieldV5,
    required: true,
  },
  {
    name: "supportCategory",
    group: "support",
    type: "select",
    icon: "fas fa-life-ring",
    className: "select ",
    component: SelectV5,
    required: false,
    orderAZ: true,
  },
  {
    name: "featureCategory",
    group: "common",
    type: "select",
    icon: "fas fa-life-ring",
    className: "select ",
    component: SelectV5,
    required: false,
    orderAZ: true,
  },
  {
    name: "issue",
    group: "support",
    type: "text",
    className: "textarea",
    component: TextareaV5,
    rows: 5,
    required: true,
    charLimit: 500,
  },
];

export { INPUT_FIELDS };
